import React, { useEffect, useState } from "react";
import { UploadCloud, X } from "lucide-react";
import "./styles/ImageUpload.css";

const BaseURL = process.env.REACT_APP_API_BASE_URL || "";

const ImageUploadSingle = ({
  id,
  label,
  value,
  onChange,
  error,
  touched,
  accept = "image/*",
}) => {
  const [preview, setPreview] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!value) {
      setPreview("");
      return;
    }

    if (value instanceof File) {
      const objectUrl = URL.createObjectURL(value);

      setPreview(objectUrl);

      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    }

    if (typeof value === "string") {
      const imageUrl = value.startsWith("http")
        ? value
        : `${BaseURL.replace(/\/$/, "")}/${value.replace(
          /^\//,
          ""
        )}`;

      setPreview(imageUrl);
    }
  }, [value]);


  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      return;
    }

    onChange(file);
  };


  const handleRemove = () => {
    onChange(null);
    setPreview("");
  };

  return (
    <div className="image-upload-wrapper">
      <label className="col-form-label">
        {label}
      </label>

      <div
        className={`upload-box ${isDragging ? "active" : ""
          } ${preview ? "has-preview" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => {
          setIsDragging(false);
        }}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);

          const file = e.dataTransfer.files?.[0];

          handleFile(file);
        }}
      >
        {/* File input */}

        <input
          id={id}
          name={id}
          type="file"
          accept={accept}
          className="file-input"
          onChange={(e) => {
            const file = e.target.files?.[0];

            handleFile(file);

            e.target.value = "";
          }}
        />

        {!preview ? (
          <div className="upload-content">
            <div className="icon-wrapper">
              <UploadCloud
                size={42}
                strokeWidth={1.5}
                color="#e4715f"
              />
            </div>

            <h6>
              Drag & Drop or <span>Browse</span>
            </h6>

            <small>
              PNG, JPG, WEBP (Max 2MB)
            </small>
          </div>
        ) : (
          /* ===================================================
             IMAGE PREVIEW
          =================================================== */

          <div className="preview-inside-box">
            <div className="preview-item">
              <img
                src={preview}
                alt="preview"
                className="inside-preview"
                onError={() => {
                  console.error(
                    "Image failed:",
                    preview
                  );
                }}
              />

              {/* Remove button */}

              <button
                type="button"
                className="remove-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  handleRemove();
                }}
              >
                <X size={14} />
              </button>
            </div>
          </div>
        )}
      </div>

      {error && touched && (
        <small className="text-danger">
          {error}
        </small>
      )}
    </div>
  );
};

export default ImageUploadSingle;